import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncRichTextEditor = Loadable({
  delay: 500,
  loader: () => import(
  // @ts-expect-error untyped dependency
  /* webpackChunkName: "rich-text-editor" */
  'FormsUI/components/common/RichTextEditor'),
  LoadingComponent: ({
    pastDelay
  }) => {
    return pastDelay ? /*#__PURE__*/_jsx("div", {
      style: {
        position: 'relative',
        height: 137
      },
      children: /*#__PURE__*/_jsx(LoadingOverlay, {
        contextual: true
      })
    }) : null;
  }
});
export default AsyncRichTextEditor;